<app-header></app-header>
<br />

<main class="main-content">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="col-lg-12">
          <div
            class="d-flex align-items-center user-member__title mb-30 mt-30"
            style="padding-top: 20px"
          >
            <h4 class="text-capitalize">
              <!-- Profile -->
              {{ "profile_page.title" | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-12" *ngFor="let profile of profiles">
        <div class="user-info-tab w-100 bg-white global-shadow radius-xl mb-50">
          <div class="tab-content" id="v-pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="v-pills-home"
              role="tabpanel"
              aria-labelledby="v-pills-home-tab"
            >
              <div class="row justify-content-center">
                <div class="col-xxl-4 col-10">
                  <div class="mt-sm-40 mb-sm-50 mt-20 mb-20">
                    <div class="user-tab-info-title mb-sm-40 mb-20">
                      <h5 class="fw-500">
                        <!-- Personal Information  -->
                        {{ "profile_page.personal_info_title" | translate }}
                        <b>{{ profile.email }}</b>
                      </h5>
                    </div>
                    <div class="edit-profile__body">
                      <p>
                        <!-- Your personal details shown below are used to process data
                        deletion requests on your behalf. -->
                        {{ "profile_page.personal_info_note_1" | translate }}
                        <br />
                        <!-- To ensure accuracy and compliance, this information can
                        only be updated by our team. -->
                        {{ "profile_page.personal_info_note_2" | translate }}
                        <br />
                        <!-- If you need to make changes, please contact us and we’ll
                        be happy to help. -->
                        {{ "profile_page.personal_info_note_3" | translate }}
                      </p>
                      <br />
                      <form>
                        <div class="row">
                          <div class="col-md-6">
                            <label for="name1">
                              <!-- First Name -->
                              {{ "profile_page.first_name" | translate }}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="name1"
                              placeholder="{{ profile?.first_name }}"
                              disabled
                            />
                          </div>
                          <div class="col-md-6">
                            <label for="name2">
                              <!-- Last Name -->
                              {{ "profile_page.last_name" | translate }}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="name2"
                              placeholder="{{ profile?.last_name }}"
                              disabled
                            />
                          </div>
                          <div class="col-md-6">
                            <label for="name2">
                              <!-- Email -->
                              {{ "profile_page.email" | translate }}
                            </label>
                            <input
                              type="email"
                              class="form-control"
                              id="name2"
                              placeholder="{{ profile?.email }}"
                              disabled
                            />
                          </div>
                          <div class="col-md-6">
                            <label for="phoneNumber5">
                              <!-- Phone Number -->
                              {{ "profile_page.phone_number" | translate }}
                            </label>
                            <div class="phone-wrapper">
                              <span class="input-group-text">+</span>
                              <input
                                type="tel"
                                class="form-control"
                                [style.padding-left]="'25px'"
                                id="phoneNumber5"
                                placeholder="{{ profile?.masked_phone }}"
                                disabled
                              />
                              <span
                                class="eye"
                                (click)="toggleShowPhone(profile)"
                              >
                                <i
                                  *ngIf="
                                    profile?.phone !== profile?.masked_phone
                                  "
                                  class="fas fa-eye-slash"
                                ></i>
                                <i
                                  *ngIf="
                                    profile?.phone === profile?.masked_phone
                                  "
                                  class="fas fa-eye"
                                ></i>
                              </span>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="countryOption">
                              <label for="countryOption">
                                <!-- Country -->
                                {{ "profile_page.country" | translate }}
                              </label>
                              <select
                                class="js-example-basic-single js-states form-control"
                                id="countryOption"
                                disabled
                              >
                                <option value="JAN">
                                  <!-- {{ profile?.country }} -->
                                  {{
                                    translateCountry(profile.country)
                                      | translate
                                  }}
                                </option>
                                <option value="FBR">Venues</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="countryOption">
                              <label for="countryOption">
                                <!-- Region -->
                                {{ "profile_page.region" | translate }}
                              </label>
                              <select
                                class="js-example-basic-single js-states form-control"
                                id="countryOption"
                                disabled
                              >
                                <option value="JAN">
                                  <!-- {{ profile?.state_region }} -->
                                  {{ translateRegion(profile) | translate }}
                                </option>
                                <option value="FBR">Venues</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </form>

                      <div class="col-md-6">
                        <br />
                        <label for="name1">
                          <!-- Signed Authorization Form -->
                          {{ "profile_page.signed_auth_form" | translate }}
                        </label>
                        <div class="files-area__left d-flex align-items-center">
                          <div class="files-area__img">
                            <img
                              src="assets/img/pdf@2x.png"
                              alt="img"
                              class="wh-42"
                            />
                          </div>
                          <div class="files-area__title">
                            <p
                              class="mb-0 fs-14 fw-500 color-dark text-capitalize"
                            >
                              {{
                                "profile_page.authorization_form_prefix"
                                  | translate
                              }}_{{ profile?.first_name }}_{{
                                profile?.last_name
                              }}.pdf
                            </p>
                            <div class="d-flex text-capitalize">
                              <a
                                href="#"
                                class="fs-12 fw-500 color-primary ms-10"
                                (click)="downloadAgreement($event, profile)"
                              >
                                <!-- Download -->
                                {{ "profile_page.download" | translate }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer></app-footer>
